import { AvailableLocale } from '@/i18n/LanguageProvider/shared';
import { DEFAULT_LOCALE } from '@/i18n/messages';

export const locale = (
  typeof window !== 'undefined' ? window.navigator.language : DEFAULT_LOCALE
) as AvailableLocale;
